<div
  class="page-content"
  [class.page-content--admin-mode]="adminMode"
  [class.is-scrolling]="isScrolling"
>
  @let header = globalDataService.config().header;
  <app-header
    [styles]="header.data.styles"
    [logoDisplay]="header.data.logo.display"
    [logoSrc]="header.data.logo.src_data"
    [logoRedirect]="header.data.logo.redirect"
    [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
  ></app-header>
  @defer {
    <div class="search-content">
      <div class="sidebar-bg" [class.show-mobile]="showMobileFilters"></div>
      <div
        class="sidebar"
        [class.is-stuck]="isScrolling"
        [class.show-mobile]="showMobileFilters"
      >
        <app-filter-panel-container
          [style.max-height]="getFilterPanelMaxHeight()"
          (closeClicked)="showMobileFilters = false"
          [containerStyles]="pageConfig().components.filterContainer.data.styles.filterContainer"
          [config]="pageConfig().components.filterContainer"
        />
      </div>
      <div class="content">
        <app-search
          [isSticky]="true"
          [withFilters]="true"
        ></app-search>
        @if (assets && searchService.pagination && !isLoading()) {
          @if (searchService.totalResults) {
            <div class="results-header">
              <span>{{ totalResults.replace('{searchResultsTotal}', searchService.totalResults.toString()) }}</span>
              <app-sort />
            </div>
          }
          @if (searchService.totalResults) {
            <div class="mobile-results-header">
              <span>{{ totalResults.replace('{searchResultsTotal}', searchService.totalResults.toString()) }}</span>
            </div>
          }
          @let searchGrid = pageConfig().components.searchGrid;
          <app-search-grid
            [assetCardConfig]="searchGrid.data.components.assetCard"
            [assets]="assets"
          ></app-search-grid>
        } @else {
          <div class="results-loading">
            <mat-spinner aria-label="loading" diameter="50"></mat-spinner>
          </div>
        }
      </div>
    </div>
  } @error {
    <app-error></app-error>
  }
  @let footer = globalDataService.config().footer;
  <app-footer
    [styles]="footer.data.styles"
    [address]="footer.data.address"
    [address_line_2]="footer.data.address_line_2"
    [phone]="footer.data.phone"
    [email]="footer.data.email"
    [facebook]="footer.data.facebook"
    [twitter]="footer.data.twitter"
    [instagram]="footer.data.instagram"
    [youtube]="footer.data.youtube"
    [linkedin]="footer.data.linkedin"
    [copyright_text]="footer.data.copyright_text"
    [link_1_text]="footer.data.link_1_text"
    [link_1_url]="footer.data.link_1_url"
    [link_2_text]="footer.data.link_2_text"
    [link_2_url]="footer.data.link_2_url"
    [link_3_text]="footer.data.link_3_text"
    [link_3_url]="footer.data.link_3_url"
  ></app-footer>
</div>